<template>
  <div
    v-show="!closed"
    class="relative w-[362px] p-6 rounded-16 bg-elev-modal-bg text-center shadow-overlay"
  >
    <button>
      <wui-icon
        name="closeRegularMdM"
        class="absolute top-2 right-2 text-fg-base-fg10 hover:opacity-60"
        small
        @click="closed = true"
      />
    </button>
    <p class="text-body-m-15-22 text-fg-base-fg3">
      {{ $t('calls.askYouToTurnDevice', { name: request.name, device }) }}
    </p>
    <p class="mt-2 text-body-r-14-20 text-fg-base-fg10">
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { computed, toRefs, ref } from 'vue'

import { StoredEnablingMediaRequest } from '@/entities/conference-participant'

import { useLocalization } from '@/shared/composables/localization'

const props = defineProps<{
  request: StoredEnablingMediaRequest
}>()

const { request } = toRefs(props)

const { t } = useLocalization()

const closed = ref(false)

const device = computed(() => {
  let device = ''
  if (request.value.audio) {
    device += t('calls.toMic')

    if (request.value.video) {
      device +=` ${ t('common.and') } `
    }
  }

  if (request.value.video) {
    device += t('calls.toVideoCam')
  }

  return device
})

const description = computed(() => {
  let description = ''
  if (request.value.audio) {
    description += t('calls.toTurnOnMicClick')

    if (request.value.video) {
      description += ' '
    }
  }

  if (request.value.video) {
    description += t('calls.toTurnOnVideoClick')
  }

  return description
})
</script>
